import { msalInstance } from '@/features/auth/lib/msalConfig'

/**
 * Prepares MSAL for use before React mounts.
 *
 * msal-browser v3 requires `initialize()` to be awaited before any MSAL API or
 * hook is called — rendering earlier produces a blank page. `handleRedirectPromise()`
 * then processes the response from AAD and clears MSAL's "interaction in progress"
 * flag; without it a failed redirect leaves the flag stuck and every later
 * `loginRedirect()` rejects silently.
 */
export async function bootstrapAuth(): Promise<void> {
  await msalInstance.initialize()

  const result = await msalInstance.handleRedirectPromise()
  const account = result?.account ?? msalInstance.getAllAccounts()[0]

  if (account) msalInstance.setActiveAccount(account)
}
